// ie polyfill
import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'

import VxeUIBase, { VxeUI } from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/es/style.css'
import VxeUIPluginExportXLSX from '@vxe-ui/plugin-export-xlsx'
import ExcelJS from 'exceljs'

// mock
import bootstrap from './core/bootstrap'
import './core/use'
import './permission' // permission control
import './utils/filter' // global filter
import i18n from './locales'
import 'ant-design-vue/dist/antd.css'
import moment from 'moment'
import 'moment/locale/zh-cn'
//图表组件
import kBuildForm from '@/components/KBuildForm'
import './plugs/xtable/renderer/filter'
// Vue.use(vSelectPage)
import clipboard from 'clipboard'
import SignV from './plugs/sign_modal/sign'
import Unlock from './plugs/unlock_modal/unlock'
import 'vant/lib/index.css'
import Vant from 'vant'
import $ from 'jquery'
import Print from '@/plugs/print'
//图标库组件
import '../src/assets/font_icon/iconfont.css'
import '../src/assets/styles/global.css'
import '@vant/touch-emulator'

import device from 'vue-device-detector'

Vue.use(Vant)

Vue.use(device)

moment.locale('zh-cn')
VxeUI.use(VxeUIPluginExportXLSX, {
  ExcelJS
})
Vue.use(VxeUIBase)
Vue.use(VxeUITable)
VxeUITable.interceptor.add('event.clearEdit', (params) => {
  const { $event } = params
  // 比如点击了某个组件的弹出层面板之后，此时被激活单元格不应该被自动关闭，通过返回 false 可以阻止默认的行为。
  if ($event.target.className.indexOf('other-popper') > -1) {
    return false
  }
})
VxeUIBase.setConfig({
  // 恢复老版本校验样式
  cellValidMode: 'obsolete',
  // 恢复窗口默认显示确认按钮
  mode: {
    showConfirmButton: true
  },
  input: {
    clearable: true
  },
  numberInput: {
    clearable: true,
    digits: 6,
    showCurrency: true
  },
  select: {
    clearable: true,
    popupConfig: {
      transfer: true
    }
  },
  form: {
    span: 6,
    size: 'mini',
    titleAlign: 'right',
    titleWidth: '100',
    titleOverflow: true
  },
  table: {
    stripe: true,
    border: true,
    round: true,
    size: 'mini',
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
    columnConfig: {
      isHover: true,
      resizable: true
    },
    rowConfig: {
      isCurrent: true,
      isHover: true,
      resizable: true
    },
    exportConfig: {
      types: ['xlsx', 'html']
    },
    radioConfig: {
      trigger: 'row',
      highlight: true
    },
    checkboxConfig: {
      trigger: 'cell',
      highlight: true,
      reserve: true,
      isShiftKey: true
    },
    keyboardConfig: {
      isArrow: true
    },
    editConfig: {
      trigger: 'click',
      mode: 'row',
      showStatus: true
    },
    virtualXConfig: {
      enabled: true,
      gt: 60
    },
    virtualYConfig: {
      enabled: true,
      gt: 100
    }
  },
  card: {
    size: 'mini'
  },
  modal: {
    size: 'mini',
    showFooter: true,
    confirmClosable: false,
    transfer: true,
    destroyOnClose: true
  },
  pager: {
    size: 'mini',
    layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total'],
    background: true
  },
  i18n: (key, args) => i18n.t(key, args),
  // 对参数的内容自动进行国际化翻译（只对支持国际化的有效）
  translate: key => i18n.t(key),
  zIndex: 110
})

Vue.prototype.clipboard = clipboard
Vue.config.productionTip = false
// mount axios Vue.$http and this.$http
Vue.use(VueAxios)
Vue.use(kBuildForm)
//签名
Vue.prototype.$sign = SignV.install
//解锁
Vue.prototype.$unlock = Unlock.install
//打印
Vue.use(Print)
window.jQuery = $
window.$ = $

new Vue({
  router,
  store,
  i18n,
  created: bootstrap,
  data: function() {
    return {
      // executor: global.employee,
      // warehouse: global.warehouse
    }
  },
  render: h => h(App)
}).$mount('#app')
